import { Injectable } from '@angular/core';
import { DonateData } from './donate-data';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DonateChangeService {
  donateData: DonateData;
  donateDataChange: Subject<DonateData> = new Subject<DonateData>();
  time: number;
  timeChange: Subject<number> = new Subject<number>();

  donateDataList: Array<DonateData>;
  donateDataListChange: Subject<Array<DonateData>> = new Subject<Array<DonateData>>();
  constructor() { }

  updateTime(time: number) {
    this.time = time;
    this.timeChange.next(this.time);
  }
  update(donateData: DonateData) {
    this.donateData = donateData;
    this.donateDataChange.next(this.donateData);
  }

  updateDonateList(donateDataList: Array<DonateData>) {
    this.donateDataList = donateDataList;
    this.donateDataListChange.next(this.donateDataList);
  }
}
